export const WALLET_TYPE = {
  Bitcoin: "BTC",
  Ethereum: "ETH",
  InternalNetwork: "InternalNetwork"
};
